var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketingcd2C25B7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 306,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_15777_44829)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M207.219.206c-31.344 2.143-61.495 18.05-80.965 42.707-17.595 22.293-26.251 50.47-42.833 73.497-16.667 23.164-41.098 40.833-53.22 66.694-18.214 38.823.227 90.676 38.864 109.28 21.449 10.328 46.122 10.898 69.93 11.267l145.199 2.243c17.126.264 34.648.47 50.882-5.008 32.047-10.814 54.487-47.193 45.99-79.931-6.708-25.86-29.734-45.915-32.969-72.404-1.827-14.968 3.013-29.935 3.24-45.013.902-61.57-90.803-106.979-144.118-103.332z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.001 198.573h-43.388l-20.023-50.175 80.421-2.064-17.01 52.239zm-41.788-2.338h40.11l15.474-47.499-73.75 1.894 18.166 45.605z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.584 166.136l-3.045 1.62-2.855 8.951 2.691-1.815 3.209-8.756z",
    fill: "url(#prefix__paint0_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.266 174.755c-1.968-.528-4.074-.935-6.043-.423a11.288 11.288 0 00-4.069 2.275 36.056 36.056 0 00-11.891 17.084c-.285.892-.501 1.969.132 2.686.475.528 1.267.681 1.99.781a392.492 392.492 0 0017.48 2.111c.701.112 1.417.09 2.111-.063a4.455 4.455 0 001.794-1.187c2.803-2.761 4.011-6.629 5.12-10.345.555-1.546.864-3.17.913-4.813-.079-4.57-3.299-6.94-7.537-8.106z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.489 184.898l1.583 3.779a6.888 6.888 0 001.441 2.449c.944.908 2.301 1.203 3.499 1.742a8.91 8.91 0 013.794 3.23c-2.29.109-4.586.015-6.86-.28a7.017 7.017 0 01-2.054-.528c-1.271-.596-.913-2.153-2.137-2.845-.876-.496-3.135-.158-4.048-.527.507-2.671 2.697-5.336 4.782-7.02z",
    fill: "url(#prefix__paint1_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.267 26.13a61.061 61.061 0 00-13.442 81.218c2.819 4.344 6.186 8.323 8.788 12.793 4.998 8.592 7.388 19.195 15.152 25.365 6.059 4.802 14.186 5.879 21.892 6.555a9.035 9.035 0 003.784-.201c2.718-.934 3.937-4.095 4.322-6.94 1.056-7.843-1.509-15.648-3.562-23.291a182.236 182.236 0 01-3.589-77.856c1.346-7.827 5.536-21.744-4.555-25.333-9.626-3.41-21.348 1.832-28.79 7.69z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.978 25.254a61.057 61.057 0 00-13.442 81.218c2.818 4.338 6.186 8.318 8.788 12.793 4.997 8.587 7.388 19.19 15.152 25.365 6.059 4.802 14.186 5.879 21.892 6.554a9.136 9.136 0 003.784-.205c2.718-.935 3.932-4.091 4.322-6.941 1.056-7.837-1.509-15.648-3.562-23.29a182.233 182.233 0 01-3.589-77.883c1.346-7.821 5.536-21.739-4.555-25.306-9.626-3.404-21.348 1.831-28.79 7.695z",
    fill: "url(#prefix__paint2_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.354 25.143a61.058 61.058 0 0113.443 81.218c-2.819 4.344-6.186 8.318-8.788 12.793-4.998 8.587-7.388 19.195-15.152 25.365-6.059 4.802-14.192 5.879-21.892 6.555a9.245 9.245 0 01-3.789-.201c-2.713-.939-3.932-4.095-4.317-6.94-1.056-7.843 1.509-15.654 3.562-23.296a182.247 182.247 0 003.584-77.882c-1.346-7.822-5.531-21.74 4.56-25.307 9.621-3.404 21.353 1.837 28.789 7.695z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.386 27.122a61.057 61.057 0 0113.442 81.218c-2.818 4.338-6.185 8.318-8.787 12.793-4.998 8.587-7.389 19.19-15.153 25.365-6.058 4.803-14.186 5.879-21.891 6.555a9.124 9.124 0 01-3.785-.206c-2.718-.934-3.931-4.09-4.322-6.94-1.055-7.838 1.509-15.649 3.562-23.291a182.231 182.231 0 003.589-77.882c-1.345-7.827-5.536-21.744 4.555-25.333 9.626-3.378 21.348 1.858 28.79 7.721z",
    fill: "url(#prefix__paint3_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.566 49.478c2.269-9.452 6.449-18.656 13.326-25.528 9.986-9.985 24.478-14.007 38.501-15.696 13.553-1.63 27.877-1.324 40.073 4.808 15.48 7.78 25.481 24.425 27.413 41.641 1.931 17.216-3.526 34.733-12.888 49.304-6.334 9.87-14.609 18.942-17.491 30.315-1.657 6.524-1.652 13.976-6.212 18.921-2.612 2.839-6.333 4.349-9.996 5.562-12.323 4.091-28.726 5.753-39.213-3.789-6.676-6.069-7.251-15.453-10.497-23.406-5.389-13.195-15.464-23.671-20.372-37.166a78.845 78.845 0 01-2.644-44.966z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.85 49.478c1.942-9.452 5.531-18.656 11.432-25.528 8.576-9.985 21.015-14.007 33.054-15.696 11.637-1.63 23.929-1.324 34.4 4.808 13.284 7.78 21.865 24.425 23.528 41.641 1.662 17.216-3.03 34.733-11.083 49.304-5.431 9.87-12.54 18.931-15 30.315-1.419 6.524-1.419 13.976-5.33 18.921-2.238 2.839-5.441 4.349-8.571 5.584-10.555 4.09-24.652 5.752-33.661-3.79-5.726-6.069-6.222-15.453-9.009-23.406-4.629-13.205-13.273-23.692-17.496-37.192a91.128 91.128 0 01-2.264-44.96z",
    fill: "url(#prefix__paint4_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.746 196.636h-46.923a6.518 6.518 0 00-6.518 6.518v39.018a6.518 6.518 0 006.518 6.518h46.923c3.6 0 6.518-2.919 6.518-6.518v-39.018c0-3.6-2.918-6.518-6.518-6.518z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.251 205.27v37.023a6.369 6.369 0 01-3.926 5.897 6.378 6.378 0 01-2.439.489h-47.203a6.377 6.377 0 01-6.386-6.386V205.27a6.374 6.374 0 016.386-6.333h47.203a6.365 6.365 0 014.488 1.855 6.363 6.363 0 011.877 4.478z",
    fill: "url(#prefix__paint5_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.254 205.27v37.023a6.373 6.373 0 01-6.365 6.386h-41.282a6.382 6.382 0 01-4.505-1.875 6.389 6.389 0 01-1.379-2.07 6.387 6.387 0 01-.481-2.441V205.27a6.372 6.372 0 016.365-6.333h41.282a6.37 6.37 0 016.365 6.333z",
    fill: "url(#prefix__paint6_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.708 189.078a35.87 35.87 0 015.689 8.059c.163.24.229.532.185.818a1.163 1.163 0 01-.596.613 478.136 478.136 0 01-11.685 6.934 3.156 3.156 0 01-1.847.591 3 3 0 01-1.119-.438 29.917 29.917 0 01-7.12-5.583 1.187 1.187 0 01-.438-.892 1.233 1.233 0 01.581-.734 95.66 95.66 0 017.916-5.552c2.259-1.346 5.684-3.816 8.434-3.816z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.259 161.888c-2.934 1.029-5.378 3.409-8.444 3.794-.56.074-1.209.116-1.536.576-.327.459-.116 1.203.259 1.683.435.428.823.902 1.155 1.415.185.374.238.807.449 1.171.337.47.8.836 1.335 1.056 2.592 1.33 5.347 2.697 8.255 2.517a7.99 7.99 0 006.333-3.916c1.024-1.805 1.583-5.483.243-7.325-1.578-2.154-5.906-1.721-8.049-.971z",
    fill: "#606161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.568 175.14a4.258 4.258 0 01-1.504 2.19 3.16 3.16 0 01-1.921.38 11.702 11.702 0 01-1.942-.417 1.425 1.425 0 00-.903-.031 1.277 1.277 0 00-.559.527c-.25.387-.447.806-.586 1.246a2.218 2.218 0 01-.385.871 1.866 1.866 0 01-.652.347 1.832 1.832 0 01-.736.064 1.625 1.625 0 01-.782-.126 1.517 1.517 0 01-.57-1.357c-.031-.749 0-1.504.043-2.253a11.33 11.33 0 01.67-3.974c.306-.664.681-1.294 1.119-1.879 1.193-1.684 2.56-3.389 4.486-4.138a11.594 11.594 0 013.626-.575 4.25 4.25 0 011.345.068c1.779.486.95 2.729.702 4.017a29.145 29.145 0 01-1.451 5.04z",
    fill: "url(#prefix__paint7_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.391 171.097c0 .422-.068.971-.475 1.082a2.249 2.249 0 01-.3-.712c-.095-.238-.28-.486-.528-.496a.753.753 0 00-.391.137 1.385 1.385 0 00-.696.839c-.106.528.29 1.055.147 1.583-.052.19-.232.38-.422.322a.528.528 0 01-.248-.248 15.286 15.286 0 01-.987-2.016 2.759 2.759 0 01-.227-.786c-.015-.316.037-.63.153-.924a5.508 5.508 0 011.8-2.364 15.86 15.86 0 012.56-1.584c.58-.316 1.873-1.055 2.538-.527.665.527-.401 1.166-.754 1.451a5.851 5.851 0 00-2.17 4.243z",
    fill: "#606161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.585 181.869l5.278 7.389a1.765 1.765 0 001.135-1.494 6.586 6.586 0 00-.159-1.974 15.745 15.745 0 01-.19-2.982 3.17 3.17 0 01.591-2.042c.861-1.003 2.602-.702 3.5.269.897.971 1.161 2.349 1.345 3.657.376 2.421.522 4.872.438 7.321-.058 1.203-.232 2.496-1.055 3.362a4.366 4.366 0 01-2.322 1.092c-4.592.924-9.468-1.488-12.171-5.315a17.078 17.078 0 01-2.918-11.273c.57-5.32 5.04-.095 6.528 1.99z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.434 192.978c.362-.002.722.069 1.055.212.728.364.971 1.266 1.087 2.074.094.448.081.913-.037 1.356a2.109 2.109 0 01-1.055 1.124c-1.056.56-2.312.459-3.489.322-.754-.084-1.667-.317-1.852-1.055-.095-.396 0-.945-.37-1.114a.752.752 0 00-.321-.053 6.982 6.982 0 01-1.325-.031 1.416 1.416 0 01-1.056-.724 1.8 1.8 0 01.09-1.329c.459-1.257 1.214-1.441 2.375-1.177 1.573.353 3.304.285 4.898.395z",
    fill: "url(#prefix__paint8_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.194 174.132a2.048 2.048 0 011.309-1.008c2.586-.618 10.682-2.855 11.152-6.713a1.294 1.294 0 011.42-.998c1.266 0 3.283 11.928 2.945 12.186-.338.259-1.494-.295-2.111-.849a4.649 4.649 0 00-4.55-1.003c-1.024.316-2.887.749-4.628 1.124-1.251.269-2.439.528-3.204.665a1.8 1.8 0 01-1.741-.607 3.058 3.058 0 01-.76-2.512s.079-.111.168-.285z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.308 177.561c1.135-.293 1.355-3.239.492-6.581-.863-3.341-2.482-5.812-3.617-5.519-1.134.293-1.355 3.239-.492 6.58.863 3.342 2.483 5.813 3.617 5.52z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.308 177.561c1.135-.293 1.355-3.239.492-6.581-.863-3.341-2.482-5.812-3.617-5.519-1.134.293-1.355 3.239-.492 6.58.863 3.342 2.483 5.813 3.617 5.52z",
    fill: "url(#prefix__paint9_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.371 173.726c.342-.089.41-.976.15-1.983-.259-1.006-.747-1.751-1.089-1.662-.342.088-.409.975-.15 1.982.26 1.006.747 1.751 1.089 1.663z",
    fill: "url(#prefix__paint10_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.037 169.767l-1.615.211s.617 3.89 1.303 4.222l1.103-.812-.791-3.621z",
    fill: "url(#prefix__paint11_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.855 174.855s.438 1.974 1.9 2.027l-3.615.818s-1.293-.074-1.547-.597c-.253-.522-1.541-2.322.275-3.726l2.913-.892a4.507 4.507 0 00.074 2.37z",
    fill: "url(#prefix__paint12_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.435 167.799a15.043 15.043 0 002.285 8.745 5.312 5.312 0 00-3.578-.966s-1.056-3.9-.597-4.988a16.09 16.09 0 011.89-2.791z",
    fill: "url(#prefix__paint13_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.828 177.256l1.029 5.874-.042 2.386 3.13-.686-.38-2.359-1.32-5.822-2.417.607z",
    fill: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.828 177.256l1.029 5.874-.042 2.386 3.13-.686-.38-2.359-1.32-5.822-2.417.607z",
    fill: "url(#prefix__paint14_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.078 183.347c-.834-1.209-.972-2.75-1.082-4.223a2.57 2.57 0 01.332-1.857 2.4 2.4 0 011.188-.66 3.312 3.312 0 011.989-.164 2.436 2.436 0 011.436 1.542c.209.696.314 1.42.311 2.148l.095 2.274.127 2.966c.055.387-.01.781-.185 1.13-1.34 2.074-3.652-2.344-4.211-3.156z",
    fill: "url(#prefix__paint15_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.143 194.715a125.258 125.258 0 014.608 15.273c-1.805.227-3.632.043-5.447.143-5.9.327-11.168 3.626-16.134 6.824 2.987-1.926-7.067-11.505-1.895-15.036 2.28-1.583 6.634-1.905 9.289-2.898a82.473 82.473 0 009.579-4.306zM127.158 221.631a8.807 8.807 0 00-2.491-.728 9.664 9.664 0 00-3.167.459c-6.718 1.673-13.579 2.348-20.44 3.024l-21.412 2.111a745.147 745.147 0 0126.225 20.557 68.378 68.378 0 0133.714-11.221c1.678-.095 3.404-.142 4.94-.818 6.296-2.765-1.108-5.726-3.958-7.209a153.467 153.467 0 00-13.411-6.175zM292.48 255.26c6.207-2.834 12.936-4.306 19.412-6.481-4.988 2.396-10.028 4.845-14.113 8.598-5.753 5.314-9.257 13.014-15.923 17.131a19.481 19.481 0 01-17.004 1.557c.174.063 5.552-7.917 6.106-8.634 2.734-3.478 2.839-2.987 6.391-3.753 3.283-.702 3.167-.243 6.228-2.702a41.52 41.52 0 018.903-5.716zM130.855 186.139l8.508 8.787c.29.348.649.632 1.056.834.339.119.696.178 1.055.174 5.41.311 10.814.844 16.182 1.583-1.478-3.061-7.321-6.117-10.028-8.064-2.111-1.531-4.518-1.9-7.172-2.359-1.642-.296-8.651.026-9.601-.955z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.172 145.3c-5.278 7.214-4.438 18.271 1.916 24.578 8.444 8.413 22.251 7.03 34.02 5.056.987 9.78 10.687 16.831 20.425 18.171 9.737 1.341 19.49-1.678 28.858-4.655a9.715 9.715 0 0018.15 2.739c-6.091-7.589-12.229-15.252-16.551-23.966-4.322-8.713-6.729-18.699-4.898-28.251.66-3.452 1.404-7.985-1.704-9.632a6.778 6.778 0 00-3.13-.58 41.204 41.204 0 00-22.921 6.697c-2.037 1.335-4.111 2.913-6.539 3.05-1.953.111-3.81-.728-5.705-1.192-6.977-1.716-14.081 1.815-21.111 1.129-7.98-.77-15.58-.264-20.81 6.856z",
    fill: "url(#prefix__paint16_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.56 168.854c3.827 5.563 3.204 14.086-1.377 18.952-6.112 6.487-16.055 5.42-24.547 3.895-.707 7.542-7.705 12.978-14.73 14.012-7.024 1.035-14.06-1.293-20.82-3.588-.528 3.029-2.987 5.568-5.843 6.027a7.09 7.09 0 01-7.235-3.937c4.396-5.848 8.824-11.759 11.943-18.472 3.12-6.713 4.85-14.414 3.531-21.781-.475-2.639-1.008-6.154 1.23-7.426a4.683 4.683 0 012.258-.449 28.353 28.353 0 0116.535 5.183c1.473 1.029 2.967 2.243 4.719 2.349 1.404.084 2.744-.56 4.116-.919 5.03-1.324 10.155 1.399 15.242.871 5.742-.596 11.221-.206 14.978 5.283z",
    fill: "url(#prefix__paint17_linear_15777_44829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.53 225.906a126.952 126.952 0 00-17.057-.961c.584 3.269 1.247 6.52 1.989 9.754 5.13-1.425 10.63-.201 15.622 1.646 4.993 1.847 9.785 4.317 14.978 5.494a1.427 1.427 0 001.219-.1c.576-.464.148-1.383-.3-1.974-4.914-6.423-7.864-12.856-16.451-13.859z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M239.604 207.286h-58.967v8.566h58.967v-8.566zM239.604 219.15h-58.967v8.566h58.967v-8.566zM239.604 231.009h-58.967v8.566h58.967v-8.566z",
    fill: "rgb(56 120 244 )"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_15777_44829",
    x1: 239.652,
    y1: 167.382,
    x2: 243.822,
    y2: 184.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_15777_44829",
    x1: 216.761,
    y1: 190.329,
    x2: 190.077,
    y2: 216.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear_15777_44829",
    x1: 141.248,
    y1: 78.727,
    x2: 363.507,
    y2: 105.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear_15777_44829",
    x1: 279.707,
    y1: 82.997,
    x2: 119.376,
    y2: 93.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint4_linear_15777_44829",
    x1: 209.215,
    y1: 48.038,
    x2: 164.524,
    y2: 427.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint5_linear_15777_44829",
    x1: 210.754,
    y1: 180.919,
    x2: 208.121,
    y2: 416.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint6_linear_15777_44829",
    x1: 213.728,
    y1: 180.977,
    x2: 211.095,
    y2: 415.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint7_linear_15777_44829",
    x1: 218.018,
    y1: 173.166,
    x2: 230.431,
    y2: 173.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint8_linear_15777_44829",
    x1: 208.992,
    y1: 195.327,
    x2: 218.64,
    y2: 195.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint9_linear_15777_44829",
    x1: 245.497,
    y1: 171.127,
    x2: 237.757,
    y2: 173.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint10_linear_15777_44829",
    x1: 250.553,
    y1: 176.554,
    x2: 254.987,
    y2: 175.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint11_linear_15777_44829",
    x1: 243.798,
    y1: 171.709,
    x2: 240.656,
    y2: 172.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint12_linear_15777_44829",
    x1: 230.392,
    y1: 173.952,
    x2: 236.981,
    y2: 181.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint13_linear_15777_44829",
    x1: 240.634,
    y1: 172.105,
    x2: 251.652,
    y2: 172.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint14_linear_15777_44829",
    x1: 234.828,
    y1: 181.083,
    x2: 238.945,
    y2: 181.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint15_linear_15777_44829",
    x1: 234.969,
    y1: 181.705,
    x2: 240.479,
    y2: 181.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint16_linear_15777_44829",
    x1: 324.475,
    y1: 147.105,
    x2: 304.051,
    y2: 187.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint17_linear_15777_44829",
    x1: 67.297,
    y1: 170.247,
    x2: 83.605,
    y2: 200.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_15777_44829"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h406v306H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingcd2C25B7);
export default __webpack_public_path__ + "static/media/marketing.cd2c25b7.ce459ec40532c68c48955549660e5c95.svg";
export { ForwardRef as ReactComponent };